// @flow

import { gql } from '@apollo/client';

const GET_ELIGIBLE_HEALTH_PLAN = gql`
  query getEligibleHealthPlan(
    $hiosId: String!
    $subsidyAmount: Float!
    $applicants: [BasicApplicantInput]!
    $onExchange: OnExchangeEnum
    $planYear: Int!
    $zipcode: String!
    $countyFips: String
    $csr: CsrLevel
  ) {
    getEligibleHealthPlan(
      hiosId: $hiosId
      subsidyAmount: $subsidyAmount
      applicants: $applicants
      onExchange: $onExchange
      planYear: $planYear
      zipcode: $zipcode
      countyFips: $countyFips
      csr: $csr
    ) {
      plan {
        planName
        metalType
        deductibleInd
        planType
        carrier
      }
      premiumMonth
      subsidizedPremium
    }
  }
`;

export default GET_ELIGIBLE_HEALTH_PLAN;
